import React from "react";
import { useTranslation } from "contexts/i18nContext";
import "../styles/SideModal.css";

interface SideModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export default function SideModal({
  isOpen,
  setIsOpen,
  title,
  children,
}: SideModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="modal-overlay" onClick={handleClose}></div>
      <div className="side-modal">
        <div className="modal-header">
          <h2>{title}</h2>
          <button
            className="close-btn"
            onClick={handleClose}
            aria-label={t("close")}
          >
            &times;
          </button>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </>
  );
}
